import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

const STRAPI_URL = (
  process.env.REACT_APP_STRAPI_URL || 'https://strapi.prod.sendoutcards.com'
).replace(/\/+$/, '')
const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN

const httpLink = createHttpLink({
  uri: `${STRAPI_URL}/graphql`,
})

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    ...(STRAPI_TOKEN ? { Authorization: `Bearer ${STRAPI_TOKEN}` } : {}),
  },
}))

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      // Skip logging introspection errors in production environments
      if (extensions?.validationErrorCode === 'INTROSPECTION_DISABLED') {
        // Silently ignore introspection errors
        return
      }

      console.error(
        `[Strapi Apollo] GraphQL error (${operation.operationName ||
          'anonymous'}):`,
        message,
        locations,
        path,
      )
    })
  }
  if (networkError) {
    console.error('[Strapi Apollo] Network error:', networkError)
  }
})

export const strapiClient = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache({
    typePolicies: {
      // Strapi single-types often don’t have stable caching out of the box.
      // This avoids the “cache data may be lost when replacing the homepage field” warning.
      Query: {
        fields: {
          homepage: {
            merge: false,
          },
        },
      },
    },
  }),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  },
})

// Helper to build absolute media URLs from Strapi
export const toAbsUrl = (u?: string | null) =>
  !u ? undefined : u.startsWith('http') ? u : `${STRAPI_URL}${u}`
